import React from 'react'
import "./services.css"
import { BiCheck } from "react-icons/bi"

const Services = () => {
    return (
        <section id="services">
            <h5>What I Offer</h5>
            <h2>Services</h2>
            <div className="container services__container">
                {/* <article className="service">
                    <div className="service__head">
                        <h3>UI/UX Design</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                    </ul>
                </article> */}
                {/* End of Ui/Ux */}
                {/* <article className="service">
                    <div className="service__head">
                        <h3>Web Development</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                    </ul>
                </article> */}
                {/* End of Web Development */}
                <article className="service">
                    <div className="service__head">
                        <h3>Front End Development</h3>
                    </div>
                    <div className="service__list">
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Creating responsive and dynamic websites</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Front-end performance optimization</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Make high-quality code</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Designing and developing the user interface (UI) and user experience (UX).</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Use React and Next.js to develop high-performance, responsive, and user-friendly websites.</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Use React and Next.js to develop complex web applications, such as e-commerce stores, social media platforms, and SaaS applications.</p>
                        </li>
                    </div>
                </article>
                <article className="service">
                    <div className="service__head">
                        <h3>Back End Development</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Make high-quality code</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Performance optimization</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Developing REST APIs (Develop APIs for a variety of purposes, such as powering mobile apps, websites, and other software applications.).</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Real-time application development.</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Use MongoDB or MySql DataBases.</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Data processing (Node.js is also good for data processing tasks. You can use your skills to develop applications that process large amounts of data in real time).</p>
                        </li>
                        <li>
                            <div className="">
                                <BiCheck className="service__list-icon" />
                            </div>
                            <p>Authentication and authorization</p>
                        </li>
                    </ul>
                </article>
                {/* End of Front End Development */}
                {/* <article className="service">
                    <div className="service__head">
                        <h3>Content Creation</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                        <li>
                            <BiCheck className="service__list-icon" />
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
                        </li>
                    </ul>
                </article> */}
                {/* End of Content Creation */}
            </div>
        </section>
    )
}

export default Services